<template>
  <admin-wrapper title-translation-path="navbar.users" :has-buttons="false" :is-fetched="isFetched">
    <template #form>
      <v-row no-gutters justify="space-between">
        <v-col class="leftCol">
          <users-input></users-input>
        </v-col>
        <v-col class="rightCol">
          <users-groups-input></users-groups-input>
        </v-col>
      </v-row>
    </template>
  </admin-wrapper>
</template>

<script>
import { call, get } from 'vuex-pathify';
import AdminWrapper from '@/components/AdminWrapper';
import UsersInput from '@/components/UsersInput';
import UsersGroupsInput from '@/components/UsersGroupsInput';

export default {
  name: 'Users',
  components: {
    AdminWrapper,
    UsersInput,
    UsersGroupsInput,
  },
  data: () => ({
    isFetched: false,
  }),
  computed: {
    groups: get('users/groups'),
  },
  methods: {
    addUser() {},
    getUsers: call('users/getUsers'),
    getGroups: call('users/getGroups'),
    async init() {
      await Promise.all([this.getUsers(), this.getGroups()]);
      this.isFetched = true;
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.rightCol {
  @include customColSize(48);
}
.leftCol {
  @include customColSize(48);
}
</style>
